

import React, { Component } from 'react';
import { ActivityIndicator, Image, ScrollView,  Share } from 'react-native';
import { Text, Button, Tab, Tabs, Container, Icon,View, ListItem, Body, Card, CardItem, NativeBaseProvider, Spinner, } from 'native-base';
//import { withNavigationFocus, NavigationEvents } from 'react-navigation';


import db, { getUserPath } from '../acebase';
import { isLocalDatabase, liveTTScoreboardColor } from '../../livettscoreboard.config';
import { liveTTScoreboardTheme } from "../liveTTScoreboardTheme";



export default function Unauthorized(props){

    return (
        <NativeBaseProvider theme={liveTTScoreboardTheme}>
            <View justifyContent={"center"} alignItems="center">
                <Text fontSize={"5xl"} color={liveTTScoreboardColor}>Unauthorized</Text>
            </View>
        </NativeBaseProvider>
    )
}